/**
 * Referral Code Utility
 * Handles storing and retrieving referral codes from URL and localStorage
 */

const REFERRAL_CODE_KEY = 'jobsreadyai_referral_code';

/**
 * Check URL for referral code and store it
 * Should be called on app initialization
 */
export function checkAndStoreReferralCode(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get('ref');
  
  if (refCode) {
    // Store in localStorage
    localStorage.setItem(REFERRAL_CODE_KEY, refCode);
    // Clean up URL
    urlParams.delete('ref');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState({}, '', newUrl);
    return refCode;
  }
  
  return null;
}

/**
 * Get stored referral code from localStorage
 */
export function getStoredReferralCode(): string | null {
  return localStorage.getItem(REFERRAL_CODE_KEY);
}

/**
 * Clear stored referral code (after it's been used)
 */
export function clearReferralCode(): void {
  localStorage.removeItem(REFERRAL_CODE_KEY);
}

